export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/v2/landing-pages/_next/static/media/BlogIcon.56d04790.svg","height":21,"width":20};